import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import VehicleDetailsLabelAndValue from '../VehicleDetailsLabelAndValue';
import { translate } from 'react-i18next';
import { styleMerge } from '../../../../utils/utils';

class DetailsReservationListItem extends React.Component {
  getContainerStyle = () => {
    const { isSelected } = this.props;

    let style = styles.rootContainer;

    if (isSelected) {
      style = styleMerge(style, styles.selected);
    }

    return style;
  };

  render() {
    const { reservation, vehicle } = this.props;

    return (
      <div style={this.getContainerStyle()}>
        <Link style={{width: '100%'}} to={`/vehicle/${vehicle.id}/reservations/${reservation.id}`}>
          <div style={styles.listItemContainer}>
            <div style={styles.innerContainer}>
              <VehicleDetailsLabelAndValue
                label={moment(reservation.start).format('D.M.YYYY HH:mm')}
                value={reservation.description || reservation.standard_notation}
              />
              <VehicleDetailsLabelAndValue
                alignRight
                label={reservation.workshop_name}
              />
            </div>
          </div>
        </Link>
      </div>
    );
  }
}

const styles = {
  rootContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderBottom: '1px solid rgba(255,255,255,.3)',
  },
  listItemContainer: {
    padding: 10,
    width: '100%'
  },
  innerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  selected: {
    borderLeft: '4px solid #27bbff',
  },
};

export default translate('VehicleDetailsView')(DetailsReservationListItem);
